export default __webpack_public_path__ + "static/media/arranjo-express.6163a6b5.png";